module.exports = __webpack_public_path__ + "img/Group 94.a8d5867a.png";